import { Spinner } from '../../../icons/Spinner'

// improve with cell defined skeleton loading
export const Loader = ({ cols }: { cols: number }) => (
    <div className="grid place-self-center" style={{ gridRow: '1 / span 3', gridColumn: `1 / span ${cols + 1}` }}>
        <Spinner size="lg" />
    </div>
)
